export const VIEW_JIRA_HORIZONTAL_NAVIGATION_EXPERIENCE = {
	experience: 'viewHorizontalNavigation',
	analyticsSource: 'jiraHorizontalNav',
};

export const HANDLED_STATUS_CODES = [401, 403, 404];
